'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

const NAV_ITEMS = [
  { label: 'Overview', path: '/dashboard' },
  { label: 'Family Hub', path: '/family-coordination-hub' },
  { label: 'Kin Check', path: '/check-ins' },
  { label: 'Kin Chat', path: '/benefits' },
  { label: 'Records', path: '/medication-manager' },
];

export default function DesktopTopNav() {
  const pathname = usePathname();

  return (
    <header
      className="hidden lg:block fixed top-0 left-0 right-0 z-50 h-16"
      style={{
        background: 'rgba(245, 241, 235, 0.72)',
        backdropFilter: 'blur(20px) saturate(180%)',
        WebkitBackdropFilter: 'blur(20px) saturate(180%)',
        borderBottom: '1px solid rgba(214, 171, 71, 0.15)',
        boxShadow: '0 1px 0 rgba(0,0,0,0.05)',
      }}
    >
      <div className="h-full max-w-[1400px] mx-auto px-6 flex items-center justify-between">
        <Link
          href="/dashboard"
          className="font-heading text-xl font-semibold text-[#312F2F] hover:opacity-80 transition-opacity"
        >
          Kin
        </Link>

        <nav className="flex items-center gap-8 absolute left-1/2 -translate-x-1/2">
          {NAV_ITEMS.map((item) => {
            const isActive = pathname === item.path;
            return (
              <Link
                key={item.path}
                href={item.path}
                className="relative py-1 text-[14px] font-medium transition-opacity hover:opacity-70"
                style={{
                  color: isActive ? '#D6AB47' : '#312F2F',
                  fontFamily: 'Inter, sans-serif',
                }}
              >
                {item.label}
                {isActive && (
                  <span
                    className="absolute bottom-0 left-0 right-0 h-0.5 rounded-full"
                    style={{ background: '#D6AB47' }}
                  />
                )}
              </Link>
            );
          })}
        </nav>

        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2">
            <span
              className="w-2 h-2 rounded-full shrink-0"
              style={{ background: '#10B981' }}
              aria-hidden
            />
            <span className="text-sm font-medium text-[#312F2F]" style={{ fontFamily: 'Inter, sans-serif' }}>
              Margaret Chen
            </span>
          </div>
          <p className="text-xs text-[#9B9590] hidden xl:block" style={{ fontFamily: 'Inter, sans-serif' }}>
            Last check-in: Today 9:02am
          </p>
          <Link
            href="/settings"
            className="p-2 rounded-lg text-[#312F2F] hover:opacity-70 transition-opacity"
            aria-label="Settings"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
              <circle cx="12" cy="12" r="3" />
            </svg>
          </Link>
        </div>
      </div>
    </header>
  );
}
